/**
 * Coffee Cruise — AI Coffee Quiz
 *
 * ============================================================
 * SCORING TABLE (edit this to add coffees or tune weights —
 * no other logic in this file needs to change)
 * ============================================================
 * Each question's answer awards points directly to named coffees
 * (keys below must match a block's "Coffee key" setting in the
 * theme editor). "ALL" is a special key meaning every configured
 * coffee gets that many points (used by "A bit of everything").
 */
var OPTION_SCORES = {
  enjoy: {
    black: { panama: 5, ethiopia: 5, papua: 4, colombia: 4, honduras: 4, nicaragua: 3, india: 3, brazil: 2, uganda: 2, mexico: 1, caramel_ethiopia: 2, santos: 3, peru: 3, salvador: 3, tanzania: 4, guatemala: 3, greco: 2, ostro: 2, kenya: 4, levante: 2, maestro: 2 },
    espresso: { uganda: 5, mexico: 5, brazil: 5, santos: 4, colombia: 4, nicaragua: 4, india: 3, honduras: 3, caramel_ethiopia: 3, panama: 2, ethiopia: 1, papua: 2, greco: 5, ostro: 5, guatemala: 3, tanzania: 3, salvador: 3, peru: 3, kenya: 3, levante: 5, maestro: 5 },
    latte: { brazil: 5, caramel_ethiopia: 5, uganda: 5, mexico: 5, santos: 4, colombia: 4, nicaragua: 4, india: 3, honduras: 3, panama: 1, ethiopia: 1, papua: 1, greco: 5, ostro: 5, guatemala: 4, tanzania: 3, salvador: 2, peru: 2, kenya: 2, levante: 5, maestro: 5 },
    iced: { panama: 5, ethiopia: 5, colombia: 4, papua: 4, honduras: 3, caramel_ethiopia: 3, brazil: 2, tanzania: 4, salvador: 4, peru: 3, guatemala: 2, greco: 1, ostro: 1, kenya: 5, levante: 1, maestro: 1 },
    everything: { ALL: 2 }
  },
  flavour: {
    chocolate: { mexico: 5, brazil: 5, uganda: 5, santos: 5, india: 4, nicaragua: 4, colombia: 3, greco: 5, ostro: 5, tanzania: 4, guatemala: 4, salvador: 2, peru: 2, levante: 5, maestro: 5 },
    caramel: { caramel_ethiopia: 5, brazil: 5, nicaragua: 4, panama: 3, colombia: 3, honduras: 3, ostro: 5, guatemala: 4, peru: 4, greco: 3, tanzania: 2, salvador: 2 },
    nutty: { brazil: 5, colombia: 5, uganda: 4, india: 4, nicaragua: 4, santos: 4, peru: 4, ostro: 3, guatemala: 2, tanzania: 2, greco: 2, salvador: 1, levante: 3, maestro: 3 },
    fruity: { panama: 5, ethiopia: 5, papua: 5, honduras: 4, colombia: 3, salvador: 5, tanzania: 4, peru: 3, guatemala: 3, greco: 2, ostro: 1, kenya: 5 },
    floral: { ethiopia: 5, panama: 5, papua: 4, tanzania: 3, salvador: 1, peru: 1, guatemala: 1, kenya: 4 }
  },
  dessert: {
    brownie: { mexico: 5, uganda: 4, brazil: 4, santos: 4, india: 3, greco: 5, ostro: 5, guatemala: 4, tanzania: 3, salvador: 1, peru: 1, levante: 5, maestro: 5 },
    cheesecake_caramel: { caramel_ethiopia: 5, brazil: 5, nicaragua: 4, colombia: 3, ostro: 5, guatemala: 4, peru: 4, greco: 3, tanzania: 2, salvador: 2 },
    lemon_tart: { panama: 5, ethiopia: 5, papua: 4, honduras: 3, tanzania: 5, salvador: 2, peru: 2, guatemala: 1, greco: 1, ostro: 1, kenya: 4 },
    cheesecake_berry: { ethiopia: 5, panama: 4, papua: 4, colombia: 3, salvador: 5, peru: 4, guatemala: 4, tanzania: 3, greco: 1, ostro: 1, kenya: 5 },
    mousse: { mexico: 5, uganda: 5, brazil: 4, india: 3, greco: 5, ostro: 5, guatemala: 3, tanzania: 3, salvador: 1, peru: 1, levante: 5, maestro: 5 }
  },
  personality: {
    know_love: { brazil: 5, colombia: 5, santos: 5, nicaragua: 4, peru: 4, guatemala: 4, salvador: 3, tanzania: 3, greco: 3, ostro: 3, levante: 3, maestro: 3 },
    balanced: { brazil: 5, colombia: 5, nicaragua: 5, india: 4, honduras: 4, peru: 5, guatemala: 4, salvador: 3, tanzania: 3, greco: 3, ostro: 3, levante: 3, maestro: 3 },
    different: { panama: 5, papua: 5, ethiopia: 5, honduras: 4, tanzania: 4, salvador: 4, greco: 4, ostro: 3, guatemala: 2, peru: 2, kenya: 4, levante: 4, maestro: 3 },
    discover: { ethiopia: 5, panama: 5, papua: 5, honduras: 4, india: 3, salvador: 5, tanzania: 4, greco: 3, ostro: 3, guatemala: 3, peru: 2, kenya: 4, levante: 3, maestro: 3 }
  }
};

var ANSWER_LABELS = {
  enjoy: {
    black: 'Black Coffee', espresso: 'Espresso',
    latte: 'Latte / Cappuccino / Flat White', iced: 'Iced Coffee',
    everything: 'A Bit of Everything'
  },
  flavour: {
    chocolate: 'Rich Chocolate', caramel: 'Sweet Caramel', nutty: 'Nutty & Smooth',
    fruity: 'Fruity & Vibrant', floral: 'Floral & Elegant'
  },
  dessert: {
    brownie: 'Chocolate Brownie', cheesecake_caramel: 'Salted Caramel Cheesecake',
    lemon_tart: 'Lemon Tart', cheesecake_berry: 'Berry Cheesecake',
    mousse: 'Dark Chocolate Mousse'
  },
  personality: {
    know_love: "a coffee you know you'll love", balanced: 'a balanced everyday coffee',
    different: 'trying something different', discover: 'discovering exciting new flavours'
  }
};

// Fixed step order — question "6" (grinder) is conditionally skipped when
// the shopper picks "Bean-to-Cup Machine" in question "5" (brew method).
var QUESTION_ORDER = ['1', '2', '3', '4', '5', '6'];

// Single source of truth for step-number -> answer-key mapping (used by
// both progress tracking and localStorage restore).
var DIMENSION_BY_STEP = { '1': 'enjoy', '2': 'flavour', '3': 'dessert', '4': 'personality', '5': 'brew', '6': 'grind' };

(function () {
  var config = window.coffeeQuizConfig || {};
  var root = document.querySelector('[data-cq-root]');
  if (!root) return;

  var sectionEl = root.closest('.cq-section');
  var storageKey = 'cq_state_' + ((sectionEl && sectionEl.id) || root.id || 'default');

  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-cq-step]'));
  var progressWrap = root.querySelector('[data-cq-progress-wrap]');
  var progressEl = root.querySelector('[data-cq-progress]');
  var progressBar = root.querySelector('[data-cq-progress-bar]');
  var progressLabel = root.querySelector('[data-cq-progress-label]');
  var progressPercent = root.querySelector('[data-cq-progress-percent]');
  var backBtn = root.querySelector('[data-cq-back]');
  var startBtn = root.querySelector('[data-cq-start]');
  var emailForm = root.querySelector('[data-cq-email-form]');
  var emailInput = root.querySelector('[data-cq-email-input]');
  var consentInput = root.querySelector('[data-cq-consent-input]');
  var submitBtn = root.querySelector('[data-cq-submit]');
  var errorEl = root.querySelector('[data-cq-error]');
  var resultEl = root.querySelector('[data-cq-result]');
  var altWrap = root.querySelector('[data-cq-alt-wrap]');
  var altGrid = root.querySelector('[data-cq-alt-grid]');
  var retakeBtn = root.querySelector('[data-cq-retake]');
  var discountWrap = root.querySelector('[data-cq-discount]');
  var discountCodeEl = root.querySelector('[data-cq-discount-code]');
  var discountValueEl = root.querySelector('[data-cq-discount-value]');
  var discountTermsEl = root.querySelector('[data-cq-discount-terms]');
  var discountCopyBtn = root.querySelector('[data-cq-discount-copy]');
  var discountCopyText = root.querySelector('[data-cq-discount-copy-text]');

  var discount = config.discount || {};
  var discountActive = !!(discount.enabled && discount.code);

  var answers = {};
  var currentIndex = 0;
  var history = [];

  // ---------- Analytics (GA4 via dataLayer + Meta Pixel) ----------
  function track(eventName, params) {
    try {
      if (window.dataLayer) window.dataLayer.push(Object.assign({ event: eventName }, params || {}));
      if (typeof window.fbq === 'function') window.fbq('trackCustom', eventName, params || {});
    } catch (e) {
      // analytics must never break the quiz
    }
  }

  // ---------- localStorage auto-save / restore ----------
  function saveState() {
    try {
      var stepKey = steps[currentIndex] ? steps[currentIndex].dataset.step : 'welcome';
      localStorage.setItem(storageKey, JSON.stringify({ answers: answers, stepKey: stepKey }));
    } catch (e) {
      // storage may be unavailable (private browsing) — fail silently
    }
  }

  function clearState() {
    try {
      localStorage.removeItem(storageKey);
    } catch (e) {}
  }

  function loadState() {
    try {
      var raw = localStorage.getItem(storageKey);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  // ---------- Step order / conditional skip ----------
  function visibleQuestionSteps() {
    return QUESTION_ORDER.filter(function (key) {
      return key !== '6' || answers.brew !== 'bean_to_cup';
    });
  }

  function nextStepKeyAfter(stepKey, value) {
    if (stepKey === '5') {
      return value === 'bean_to_cup' ? 'email' : '6';
    }
    if (stepKey === '6') return 'email';
    var order = QUESTION_ORDER;
    var idx = order.indexOf(stepKey);
    return idx > -1 && idx < order.length - 1 ? order[idx + 1] : 'email';
  }

  function updateProgress() {
    var qSteps = visibleQuestionSteps();
    var answeredCount = qSteps.filter(function (k) {
      return answers[DIMENSION_BY_STEP[k]] !== undefined;
    }).length;
    var pct = Math.min(100, Math.round((answeredCount / qSteps.length) * 100));
    if (progressBar) progressBar.style.width = pct + '%';
    if (progressPercent) progressPercent.textContent = pct + '%';
    if (progressEl) {
      progressEl.setAttribute('aria-valuenow', String(pct));
    }
  }

  function updateProgressLabel(index) {
    if (!progressLabel) return;
    var stepKey = steps[index] ? steps[index].dataset.step : null;
    var qSteps = visibleQuestionSteps();
    var qIndex = qSteps.indexOf(stepKey);
    if (qIndex > -1) {
      progressLabel.textContent = 'Question ' + (qIndex + 1) + ' of ' + qSteps.length;
    } else if (stepKey === 'email') {
      // The bar reads 100% here, so leaving the last question's number in place
      // told the shopper they were still on question 6 with the quiz complete.
      progressLabel.textContent = 'All questions answered';
    }
  }

  function showStep(index) {
    var stepKey = steps[index] ? steps[index].dataset.step : null;
    steps.forEach(function (step, i) {
      step.classList.remove('cq-step-active');
      if (i === index) step.classList.add('cq-step-active');
    });
    currentIndex = index;
    backBtn.hidden = history.length === 0 || stepKey === 'welcome' || stepKey === 'result';
    if (progressWrap) progressWrap.hidden = stepKey === 'welcome' || stepKey === 'result';
    updateProgressLabel(index);
    saveState();
  }

  function goToStepByKey(key) {
    var idx = steps.findIndex(function (s) {
      return s.dataset.step === key;
    });
    if (idx > -1) {
      history.push(currentIndex);
      showStep(idx);
    }
  }

  function goBack() {
    var prev = history.pop();
    if (prev !== undefined) showStep(prev);
  }

  backBtn.addEventListener('click', goBack);

  if (startBtn) {
    startBtn.addEventListener('click', function () {
      track('quiz_start');
      goToStepByKey('1');
    });
  }

  if (retakeBtn) {
    retakeBtn.addEventListener('click', function () {
      answers = {};
      history = [];
      root.querySelectorAll('[data-answer]').forEach(function (b) {
        b.classList.remove('cq-option-selected');
      });
      emailForm.reset();
      setError('');
      clearState();
      updateProgress();
      showStep(0);
    });
  }

  // ---------- Answer selection (with conditional branching) ----------

  root.querySelectorAll('[data-answer]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.dataset.answer;
      var value = btn.dataset.value;
      var group = btn.closest('[data-cq-step]');
      var stepKey = group.dataset.step;

      group.querySelectorAll('[data-answer]').forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
        b.classList.remove('cq-option-selected');
      });
      btn.classList.add('cq-option-selected');
      btn.setAttribute('aria-pressed', 'true');

      answers[key] = value;

      if (stepKey === '5') {
        answers.format = value === 'bean_to_cup' ? 'beans' : undefined;
      }
      if (stepKey === '6') {
        answers.format = value === 'yes' ? 'beans' : 'ground';
      }

      track('quiz_question_answered', { question: key, answer: value });
      updateProgress();

      setTimeout(function () {
        var next = nextStepKeyAfter(stepKey, value);
        goToStepByKey(next);
      }, 220);
    });
  });

  function setError(message) {
    if (!errorEl) return;
    if (!message) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    } else {
      errorEl.hidden = false;
      errorEl.textContent = message;
    }
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  // NOTE: kept on Omnisend (with the Cloudflare proxy already set up),
  // even though earlier planning docs mention Klaviyo — switching ESPs
  // would throw away the working proxy/API key setup already in place.
  function submitToOmnisend(email) {
    var omnisend = config.omnisend || {};

    if (omnisend.proxyUrl) {
      return fetch(omnisend.proxyUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, tags: ['quiz-subscriber'], source: 'coffee-quiz' })
      });
    }

    if (omnisend.apiKey) {
      return fetch('https://api.omnisend.com/v3/contacts', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-API-KEY': omnisend.apiKey },
        body: JSON.stringify({
          identifiers: [{ type: 'email', id: email, channels: { email: { status: 'subscribed', statusDate: new Date().toISOString() } } }],
          tags: ['quiz-subscriber']
        })
      });
    }

    return Promise.resolve({ ok: true, _skipped: true });
  }

  emailForm.addEventListener('submit', function (e) {
    e.preventDefault();
    setError('');

    var email = emailInput.value.trim();
    if (!isValidEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    if (!consentInput.checked) {
      setError('Please agree to receive marketing emails to continue.');
      return;
    }

    submitBtn.disabled = true;
    submitBtn.querySelector('[data-cq-submit-text]').textContent = 'Unlocking...';

    // A blocked/failed ESP call (e.g. CORS) must not trap the shopper
    // behind the email gate forever — the submission attempt itself
    // (valid email + consent) is what unlocks results.
    submitToOmnisend(email)
      .catch(function (err) {
        console.warn('Coffee Quiz: Omnisend submission failed, continuing anyway.', err);
      })
      .then(function () {
        track('quiz_email_submitted', { email_domain: email.split('@')[1] || '' });
        renderResult();
        goToStepByKey('result');
        // The run is finished — drop the saved session (goToStepByKey has just
        // re-saved it) so the shopper's next visit starts from a clean slate.
        clearState();
        submitBtn.disabled = false;
        submitBtn.querySelector('[data-cq-submit-text]').textContent = 'Reveal My Coffee';
      });
  });

  // ---------- Scoring ----------
  function scoreCoffee(coffeeKey) {
    var score = 0;
    var contributions = [];
    Object.keys(OPTION_SCORES).forEach(function (question) {
      var value = answers[question];
      if (!value) return;
      var table = OPTION_SCORES[question][value];
      if (!table) return;
      var pts = table[coffeeKey] !== undefined ? table[coffeeKey] : (table.ALL || 0);
      if (pts > 0) {
        score += pts;
        contributions.push({ question: question, value: value, points: pts });
      }
    });
    return { score: score, contributions: contributions };
  }

  // Best possible score this coffee could ever get (sum of its own
  // highest-scoring answer per question) — the denominator for a
  // genuine match percentage, instead of comparing a coffee to itself.
  var maxScoreCache = {};
  function maxPossibleScore(coffeeKey) {
    if (maxScoreCache[coffeeKey] !== undefined) return maxScoreCache[coffeeKey];
    var max = 0;
    Object.keys(OPTION_SCORES).forEach(function (question) {
      var options = OPTION_SCORES[question];
      var best = 0;
      Object.keys(options).forEach(function (value) {
        var table = options[value];
        var pts = table[coffeeKey] !== undefined ? table[coffeeKey] : (table.ALL || 0);
        if (pts > best) best = pts;
      });
      max += best;
    });
    maxScoreCache[coffeeKey] = max;
    return max;
  }

  function compareCoffees(a, b) {
    if (Math.abs(a.score - b.score) > 2) return b.score - a.score;
    var pa = a.coffee, pb = b.coffee;
    if ((pb.sales || 0) !== (pa.sales || 0)) return (pb.sales || 0) - (pa.sales || 0);
    if ((pb.rating || 0) !== (pa.rating || 0)) return (pb.rating || 0) - (pa.rating || 0);
    if ((pb.stock || 0) !== (pa.stock || 0)) return (pb.stock || 0) - (pa.stock || 0);
    return b.score - a.score;
  }

  function rankedCoffees() {
    var coffees = (config.coffees || []).filter(function (c) {
      return c && c.coffeeKey;
    });

    // If the same coffee key is configured on more than one block (e.g. a
    // half-finished duplicate left in the theme editor), keep only the
    // block that actually has a product attached.
    var byKey = {};
    coffees.forEach(function (c) {
      var existing = byKey[c.coffeeKey];
      var hasProduct = !!(c.beans || c.ground);
      if (!existing || (hasProduct && !(existing.beans || existing.ground))) {
        byKey[c.coffeeKey] = c;
      }
    });
    var deduped = Object.keys(byKey).map(function (key) {
      return byKey[key];
    });

    var scored = deduped
      .filter(function (c) {
        // Never recommend a "perfect match" the shopper can't actually
        // buy — require at least one in-stock format.
        var beansOk = c.beans && c.beans.available !== false;
        var groundOk = c.ground && c.ground.available !== false;
        return beansOk || groundOk;
      })
      .map(function (c) {
        var result = scoreCoffee(c.coffeeKey);
        return { coffee: c, score: result.score, contributions: result.contributions };
      });
    scored.sort(compareCoffees);
    return scored;
  }

  function activeVariant(coffee) {
    var wantGround = answers.format === 'ground';
    var preferred = wantGround ? coffee.ground : coffee.beans;
    var fallback = wantGround ? coffee.beans : coffee.ground;
    // Prefer the shopper's requested format, but never hand them a sold-out
    // variant when the other format is available.
    if (preferred && preferred.available !== false) return preferred;
    if (fallback && fallback.available !== false) return fallback;
    return preferred || fallback || null;
  }

  function formatMoney(cents) {
    if (cents === null || cents === undefined) return '';
    var amount = (Number(cents) / 100).toFixed(2);
    var format = config.shopMoneyFormat || '${{amount}}';
    return format.replace('{{amount}}', amount).replace('{{ amount }}', amount);
  }

  function addToCart(variantId, button, coffeeName) {
    if (!variantId) return;
    var originalHTML = button.innerHTML;
    button.disabled = true;
    button.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () {
        track('quiz_product_click', { action: 'add_to_basket', coffee: coffeeName });
        button.textContent = 'Added ✓';
        button.classList.add('cq-added');

        // The button reverts to "Add to Basket" in 2.5s — without this the
        // results screen offers no route to checkout at all for themes that
        // don't pop a cart drawer on `cart:refresh`.
        var group = button.closest('.cq-result-actions');
        if (group && group._cartLink) group._cartLink.hidden = false;

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () {
          button.innerHTML = originalHTML;
          button.classList.remove('cq-added');
          button.disabled = false;
        }, 2500);
      })
      .catch(function () {
        button.textContent = 'Error — try again';
        setTimeout(function () {
          button.innerHTML = originalHTML;
          button.disabled = false;
        }, 2500);
      });
  }

  function buildFormatToggle(coffee, onSwitch) {
    if (!coffee.beans || !coffee.ground) return null;
    var wrap = document.createElement('div');
    wrap.className = 'cq-format-toggle';

    ['beans', 'ground'].forEach(function (fmt) {
      var variant = coffee[fmt];
      var soldOut = variant.available === false;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cq-format-btn' + (activeVariant(coffee) === variant ? ' cq-format-active' : '');
      btn.textContent = (fmt === 'beans' ? 'Whole Beans' : 'Ground Coffee') + (soldOut ? ' (Sold Out)' : '');
      if (soldOut) {
        btn.disabled = true;
        btn.classList.add('cq-format-soldout');
      } else {
        btn.addEventListener('click', function () {
          wrap.querySelectorAll('.cq-format-btn').forEach(function (b) {
            b.classList.remove('cq-format-active');
          });
          btn.classList.add('cq-format-active');
          onSwitch(variant);
        });
      }
      wrap.appendChild(btn);
    });

    return wrap;
  }

  // Safe DOM construction (no innerHTML) so merchant-entered text fields
  // (flavours, best_brew) can never inject markup/scripts into the page.
  function buildTagLine(label, value) {
    var p = document.createElement('p');
    p.className = 'cq-tag-line';
    var strong = document.createElement('strong');
    strong.textContent = label;
    p.appendChild(strong);
    p.appendChild(document.createTextNode(' ' + value));
    return p;
  }

  // Two stacked star rows with the top one clipped to the score — a 4.6 reads
  // as 4.6 stars instead of being rounded up to 5, which is the whole point of
  // showing a rating rather than a badge.
  //
  // Live Judge.me data on the product wins; the block's own rating is only a
  // fallback. A review *count* is shown only when it came from Judge.me — a
  // hand-typed count in the theme editor goes stale the day it's entered.
  function buildRating(coffee, variant) {
    variant = variant || {};
    var live = Number(variant.reviewRating) || 0;
    var rating = live || Number(coffee.rating) || 0;
    if (rating <= 0) return null;

    var scaleMax = live ? (Number(variant.reviewScaleMax) || 5) : 5;
    if (scaleMax <= 0) scaleMax = 5;

    var count = live ? (Number(variant.reviewCount) || 0) : 0;

    var wrap = document.createElement('span');
    wrap.className = 'cq-rating';

    var stars = document.createElement('span');
    stars.className = 'cq-stars';
    stars.setAttribute('aria-hidden', 'true');

    var base = document.createElement('span');
    base.className = 'cq-stars-base';
    base.textContent = '★★★★★';
    stars.appendChild(base);

    var fill = document.createElement('span');
    fill.className = 'cq-stars-fill';
    fill.textContent = '★★★★★';
    fill.style.width = Math.max(0, Math.min(100, (rating / scaleMax) * 100)) + '%';
    stars.appendChild(fill);

    wrap.appendChild(stars);

    var num = document.createElement('span');
    num.className = 'cq-rating-num';
    num.textContent = rating.toFixed(1);
    wrap.appendChild(num);

    var label = rating.toFixed(1) + ' out of ' + scaleMax + ' stars';
    if (count > 0) {
      var countEl = document.createElement('span');
      countEl.className = 'cq-rating-count';
      countEl.textContent = '(' + count + ')';
      wrap.appendChild(countEl);
      label += ' from ' + count + ' reviews';
    }
    wrap.setAttribute('aria-label', label);

    return wrap;
  }

  function buildProofRow(coffee, variant) {
    var rating = buildRating(coffee, variant);
    var badgeText = coffee.badge ? String(coffee.badge).trim() : '';
    if (!rating && !badgeText) return null;

    var row = document.createElement('div');
    row.className = 'cq-proof-row';

    if (badgeText) {
      var pill = document.createElement('span');
      pill.className = 'cq-proof-badge';
      pill.textContent = badgeText;
      row.appendChild(pill);
    }
    if (rating) row.appendChild(rating);

    return row;
  }

  function buildPriceEl(variant) {
    var priceEl = document.createElement('p');
    priceEl.className = 'cq-result-price';
    priceEl.textContent = formatMoney(variant.price);
    if (variant.comparePrice && variant.comparePrice > variant.price) {
      var compare = document.createElement('span');
      compare.className = 'cq-compare-price';
      compare.textContent = formatMoney(variant.comparePrice);
      priceEl.appendChild(compare);
    }
    return priceEl;
  }

  // `ref` is a mutable { variant } box — the format toggle updates
  // ref.variant, and these controls always read the current value from
  // it at click-time, instead of capturing a stale variant by value.
  function buildActions(ref, coffeeName) {
    var actions = document.createElement('div');
    actions.className = 'cq-result-actions';

    var addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'cq-add-cart-btn';
    addBtn.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg><span>Add to Basket</span>';
    addBtn.addEventListener('click', function () {
      addToCart(ref.variant.variantId, addBtn, coffeeName);
    });
    actions.appendChild(addBtn);

    var cta = document.createElement('a');
    cta.className = 'cq-result-cta';
    cta.href = ref.variant.url || '#';
    cta.textContent = 'View Coffee';
    cta.addEventListener('click', function () {
      track('quiz_product_click', { action: 'view_coffee', coffee: coffeeName });
    });
    actions.appendChild(cta);

    if (config.showCartLink !== false) {
      var cartLink = document.createElement('a');
      cartLink.className = 'cq-cart-link';
      cartLink.href = config.cartUrl || '/cart';
      cartLink.hidden = true;
      cartLink.innerHTML = '<span>Go to basket</span><svg aria-hidden="true" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>';
      cartLink.addEventListener('click', function () {
        track('quiz_product_click', { action: 'go_to_basket', coffee: coffeeName });
      });
      actions.appendChild(cartLink);
      actions._cartLink = cartLink;
    }

    actions._cta = cta;
    return actions;
  }

  function buildWhyPickedList(entry) {
    var ul = document.createElement('ul');
    ul.className = 'cq-bullet-list';
    var seen = {};
    entry.contributions
      .sort(function (a, b) { return b.points - a.points; })
      .forEach(function (c) {
        var label = (ANSWER_LABELS[c.question] || {})[c.value];
        if (!label || seen[label]) return;
        seen[label] = true;
        var li = document.createElement('li');
        li.textContent = label;
        ul.appendChild(li);
      });
    return ul;
  }

  // Genuine match quality: this coffee's actual score against the best
  // score it could theoretically ever get — not against another coffee,
  // so the percentage actually reflects how well the answers fit.
  function matchPercent(entry) {
    var max = maxPossibleScore(entry.coffee.coffeeKey);
    if (max <= 0) return 60;
    return Math.max(40, Math.min(99, Math.round((entry.score / max) * 100)));
  }

  function buildBestMatchCard(entry) {
    var coffee = entry.coffee;
    var variant = activeVariant(coffee);
    var percent = matchPercent(entry);

    var card = document.createElement('div');
    card.className = 'cq-result-card cq-best-match';

    var badge = document.createElement('span');
    badge.className = 'cq-best-match-badge';
    badge.textContent = '⭐ Your Perfect Match (' + percent + '%)';
    card.appendChild(badge);

    if (variant && variant.image) {
      var imgWrap = document.createElement('div');
      imgWrap.className = 'cq-result-image-wrap cq-result-image-wrap-lg';
      var img = document.createElement('img');
      img.className = 'cq-result-image';
      img.src = variant.image;
      img.alt = coffee.name || 'Coffee';
      imgWrap.appendChild(img);
      card.appendChild(imgWrap);
    }

    // Everything except the badge and the image lives in one wrapper, so the
    // desktop layout is a plain two-column grid (image | body) instead of
    // needing every child placed and row-spanned individually.
    var body = document.createElement('div');
    body.className = 'cq-card-body';
    card.appendChild(body);

    var title = document.createElement('h4');
    title.className = 'cq-result-title cq-best-title';
    title.textContent = coffee.name || 'Coffee';
    body.appendChild(title);

    // Beans and ground are separate products with separate Judge.me reviews,
    // so this row is re-rendered whenever the format toggle switches product.
    var proofRow = buildProofRow(coffee, variant);
    if (proofRow) title.insertAdjacentElement('afterend', proofRow);

    function refreshProof(newVariant) {
      var fresh = buildProofRow(coffee, newVariant);
      if (proofRow && fresh) {
        proofRow.replaceWith(fresh);
      } else if (proofRow) {
        proofRow.remove();
      } else if (fresh) {
        title.insertAdjacentElement('afterend', fresh);
      }
      proofRow = fresh;
    }

    if (coffee.country) {
      var origin = document.createElement('p');
      origin.className = 'cq-origin-line';
      origin.textContent = 'Origin: ' + coffee.country;
      body.appendChild(origin);
    }

    if (coffee.description) {
      var desc = document.createElement('p');
      desc.className = 'cq-desc-line';
      desc.textContent = coffee.description;
      body.appendChild(desc);
    }

    if (coffee.flavours) {
      body.appendChild(buildTagLine('Flavour notes:', coffee.flavours));
    }

    if (coffee.bestBrew) {
      body.appendChild(buildTagLine('Great for:', coffee.bestBrew));
    }

    if (entry.contributions.length) {
      var whyHeading = document.createElement('p');
      whyHeading.className = 'cq-bullet-heading';
      whyHeading.textContent = 'Why we picked it:';
      body.appendChild(whyHeading);
      body.appendChild(buildWhyPickedList(entry));
    }

    var ref = { variant: variant || {} };

    var toggle = buildFormatToggle(coffee, function (newVariant) {
      ref.variant = newVariant;
      var freshPrice = buildPriceEl(newVariant);
      priceEl.replaceWith(freshPrice);
      priceEl = freshPrice;
      actions._cta.href = newVariant.url || '#';
      refreshProof(newVariant);

      var imgEl = card.querySelector('.cq-result-image');
      if (newVariant.image) {
        if (imgEl) {
          imgEl.src = newVariant.image;
        } else {
          var newWrap = document.createElement('div');
          newWrap.className = 'cq-result-image-wrap cq-result-image-wrap-lg';
          var newImg = document.createElement('img');
          newImg.className = 'cq-result-image';
          newImg.src = newVariant.image;
          newImg.alt = coffee.name || 'Coffee';
          newWrap.appendChild(newImg);
          badge.insertAdjacentElement('afterend', newWrap);
        }
      } else if (imgEl) {
        imgEl.closest('.cq-result-image-wrap').remove();
      }
    });
    if (toggle) body.appendChild(toggle);

    var priceEl = buildPriceEl(ref.variant);
    body.appendChild(priceEl);

    var actions = buildActions(ref, coffee.name);
    body.appendChild(actions);

    return card;
  }

  function buildAltCard(entry) {
    var coffee = entry.coffee;
    var variant = activeVariant(coffee);
    var card = document.createElement('div');
    card.className = 'cq-result-card';

    if (variant && variant.image) {
      var imgWrap = document.createElement('div');
      imgWrap.className = 'cq-result-image-wrap';
      var img = document.createElement('img');
      img.className = 'cq-result-image';
      img.src = variant.image;
      img.alt = coffee.name || 'Coffee';
      imgWrap.appendChild(img);
      card.appendChild(imgWrap);
    }

    // Same wrapper as the best-match card, so both switch to a landscape
    // image | body layout on desktop with one grid rule instead of per-child
    // placement.
    var body = document.createElement('div');
    body.className = 'cq-card-body';
    card.appendChild(body);

    var title = document.createElement('h4');
    title.className = 'cq-result-title';
    title.textContent = coffee.name || 'Coffee';
    body.appendChild(title);

    var proof = buildProofRow(coffee, variant);
    if (proof) body.appendChild(proof);

    body.appendChild(buildPriceEl(variant || {}));
    body.appendChild(buildActions({ variant: variant || {} }, coffee.name));

    return card;
  }

  // ---------- Discount reward ----------

  // Shopify sets the cart-level discount from a GET to /discount/{code} — it
  // normally 302s to the storefront, which is fine here because we only want
  // the cookie it sets. A bad/expired code just means no discount; it must
  // never interfere with the add-to-cart that triggered it.
  function applyDiscountToCart() {
    if (!discountActive || !discount.autoApply) return;
    try {
      fetch('/discount/' + encodeURIComponent(discount.code), { credentials: 'same-origin' })
        .catch(function () {});
    } catch (e) {}
  }

  function copyDiscountCode() {
    var reset = function (label) {
      if (!discountCopyText) return;
      discountCopyText.textContent = label;
      setTimeout(function () {
        discountCopyText.textContent = 'Copy code';
      }, 2000);
    };

    // The async Clipboard API needs a secure context and can still be denied,
    // so fall back to a throwaway selection before giving up on the shopper.
    var legacyCopy = function () {
      try {
        var range = document.createRange();
        range.selectNodeContents(discountCodeEl);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
        var ok = document.execCommand('copy');
        // Only tidy the selection away on success — when we fall back to
        // telling the shopper to press Ctrl+C, the code has to stay selected
        // for that instruction to do anything.
        if (ok) sel.removeAllRanges();
        reset(ok ? 'Copied ✓' : 'Press Ctrl+C');
      } catch (e) {
        reset('Press Ctrl+C');
      }
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(discount.code).then(function () {
        reset('Copied ✓');
      }, legacyCopy);
    } else {
      legacyCopy();
    }

    track('quiz_discount_copied', { code: discount.code });
  }

  if (discountCopyBtn) discountCopyBtn.addEventListener('click', copyDiscountCode);

  function renderDiscount() {
    if (!discountWrap) return;
    if (!discountActive) {
      discountWrap.hidden = true;
      return;
    }
    discountWrap.hidden = false;

    // Applied here rather than on add-to-cart: shoppers who leave via "View
    // Coffee" and buy from the product page would otherwise never get it, and
    // a fetch fired during that navigation is not reliably delivered.
    applyDiscountToCart();

    if (discountCodeEl) discountCodeEl.textContent = discount.code;
    if (discountValueEl) discountValueEl.textContent = discount.label || '10% OFF';
    if (discountTermsEl) {
      discountTermsEl.textContent = discount.terms || '';
      discountTermsEl.hidden = !discount.terms;
    }
  }

  function renderResult() {
    var ranked = rankedCoffees();
    resultEl.innerHTML = '';

    // Runs before the no-match early return — the email was already handed
    // over, so the promised reward is owed either way.
    renderDiscount();

    if (!ranked.length) {
      var fallback = document.createElement('p');
      fallback.textContent = 'We could not find a matching product yet. Please check back soon!';
      resultEl.appendChild(fallback);
      if (altWrap) altWrap.hidden = true;
      return;
    }

    var top = ranked.slice(0, 3);
    resultEl.appendChild(buildBestMatchCard(top[0]));

    // Only show genuinely relevant alternates — padding "You'll Also
    // Love" with a zero-score coffee isn't a real recommendation.
    var alternates = top.slice(1).filter(function (entry) {
      return entry.score > 0;
    });
    if (altGrid && altWrap) {
      altGrid.innerHTML = '';
      alternates.forEach(function (entry) {
        altGrid.appendChild(buildAltCard(entry));
      });
      altWrap.hidden = alternates.length === 0;
    }

    track('quiz_result_viewed', {
      top_coffee: top[0].coffee.coffeeKey,
      second: top[1] ? top[1].coffee.coffeeKey : null,
      third: top[2] ? top[2].coffee.coffeeKey : null
    });
  }

  // ---------- Restore from localStorage on load ----------
  function restore() {
    var saved = loadState();
    if (!saved || !saved.answers || Object.keys(saved.answers).length === 0) return false;

    // Only a session parked mid-quiz is resumable. A finished run (or one
    // already reset back to the welcome screen) must NOT adopt its answers:
    // doing so leaves a full answer set behind a fresh start, which pins the
    // progress bar at 100% from question one and pre-selects every option.
    var resumable = saved.stepKey && saved.stepKey !== 'result' && saved.stepKey !== 'welcome';
    if (!resumable) {
      clearState();
      return false;
    }

    // Resolve the target step before touching any state — an unknown key
    // (e.g. saved by an older version of the quiz) would otherwise leave every
    // step hidden behind a half-applied restore.
    var idx = steps.findIndex(function (s) {
      return s.dataset.step === saved.stepKey;
    });
    if (idx === -1) {
      clearState();
      return false;
    }

    // Keep only the answers the shopper had genuinely completed *before* the
    // saved step. Anything from the resume step onwards is stale — a finished
    // run that was later restarted saves its full answer set against an early
    // step, which would otherwise resume question 1 with every question
    // counted and the progress bar stuck at 100%.
    var resumeAt = QUESTION_ORDER.indexOf(saved.stepKey); // -1 on the email step
    var restored = {};
    Object.keys(saved.answers).forEach(function (k) {
      restored[k] = saved.answers[k];
    });
    if (resumeAt > -1) {
      QUESTION_ORDER.slice(resumeAt).forEach(function (key) {
        delete restored[DIMENSION_BY_STEP[key]];
      });
      // `format` is derived from the brew/grinder questions, both of which are
      // at or after any resume point inside QUESTION_ORDER.
      delete restored.format;
    }

    // Nothing survived the prune — treat it as a fresh visitor rather than
    // dropping them onto a bare question step.
    if (Object.keys(restored).length === 0) {
      clearState();
      return false;
    }

    answers = restored;
    Object.keys(DIMENSION_BY_STEP).forEach(function (stepKey) {
      var dim = DIMENSION_BY_STEP[stepKey];
      var value = answers[dim];
      if (!value) return;
      var btn = root.querySelector('[data-answer="' + dim + '"][data-value="' + value + '"]');
      if (btn) {
        btn.classList.add('cq-option-selected');
        btn.setAttribute('aria-pressed', 'true');
      }
    });
    updateProgress();

    history.push(currentIndex);
    showStep(idx);
    return true;
  }

  if (!restore()) {
    showStep(0);
  }
  updateProgress();
})();
